import { Toggle } from '@pantry/ui'
import React from 'react'
import { useRuleCardEdit } from './RuleCardEditContext'

interface RuleToggleProps {
  checked: boolean
  onChange: (next: boolean) => void
  disabled?: boolean
  // Header enable toggles stay interactive regardless of edit mode; row-level
  // toggles only become interactive while the card is in edit mode.
  forceEnabled?: boolean
}

export const RuleToggle: React.FC<RuleToggleProps> = ({
  checked,
  onChange,
  disabled,
  forceEnabled,
}) => {
  const { isEditing } = useRuleCardEdit()
  const isDisabled = disabled || (!forceEnabled && !isEditing)
  return <Toggle checked={checked} onChange={onChange} disabled={isDisabled} />
}
